const videoIdPattern = /^[\w-]{11}$/;
const youtubeHosts = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'];

export function parseYoutubeVideoId(input: string): string | null {
  const url = parseUrl(input.trim());
  if (!url) return null;
  const candidate = extractCandidateId(url);
  return candidate && videoIdPattern.test(candidate) ? candidate : null;
}

export function youtubeWatchUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function youtubeEmbedUrl(videoId: string, { autoplay }: { autoplay: boolean }): string {
  return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&fs=0${autoplay ? '&autoplay=1' : ''}`;
}

export function youtubeThumbnailUrl(videoId: string): string {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}

function extractCandidateId(url: URL): string | null {
  if (url.hostname === 'youtu.be') return url.pathname.split('/')[1] ?? null;
  if (!youtubeHosts.includes(url.hostname)) return null;
  if (url.pathname === '/watch') return url.searchParams.get('v');

  const [, prefix, id] = url.pathname.split('/');
  return prefix && ['embed', 'shorts', 'live', 'v'].includes(prefix) ? (id ?? null) : null;
}

function parseUrl(input: string): URL | null {
  try {
    return new URL(/^https?:\/\//.test(input) ? input : `https://${input}`);
  } catch {
    return null;
  }
}
